<script>
import weatherIcon from '../weatherIcon';

export default {
  name: "Hour",
  props: {
    hour: Object,
    maxTemp: Number,
    minTemp: Number
  },
  computed: {
    formatedHour() {
      const d = new Date(this.hour.dt * 1000);
      return (d.getHours() < 10 ? d.getHours() : d.getHours()) + 'h';
    },
    style() {
      const ratio = (this.hour.temp - this.minTemp) / this.maxTemp;

      return {
        height: 110 + 100 * ratio + 'px'
      }
    },
    icon() {
      return weatherIcon(this.hour.weather[0].id);
    }
  },
};
</script>
<template>
  <div class="hour" :style="style">
    <!-- <div class="rain">45%</div> -->
    <img :src="icon" :alt="hour.weather[0].id" class="icon" />
    <div class="temp">{{ hour.temp.toFixed(0) }} °</div>
    <div class="time">{{ formatedHour }}</div>
  </div>
</template>
<style lang="scss">
.hourly .hours .hour {
  height: 110px;
  width: 3rem;
  //background-color: var(--text-color);
  background-color: var(--card-color);
  border: solid 2px var(--text-color);
  //color: var(--background-color);
  margin: 0.5rem;
  flex: 0 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  border-radius: .4rem;
  box-shadow: var(--light-shadow);

  .rain {
    margin: 0;
    font-size: .8rem;
    font-weight: bold;
    color: #5fdaff;
  }

  .icon {
    width: 70%;
    margin: .2rem 0;
  }

  .temp {
    font-size: 1rem;
    font-weight: bold;
    margin: .25rem 0;
  }

  .time {
    font-size: .8rem;
    margin-bottom: .5rem;
  }
}
</style>